import { render, staticRenderFns } from "./menu-items.vue?vue&type=template&id=94910f04&"
import script from "./menu-items.vue?vue&type=script&lang=js&"
export * from "./menu-items.vue?vue&type=script&lang=js&"
import style0 from "./menu-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports